// Tooltip.tsx
import React, { useState, useRef, useEffect } from 'react';

interface TooltipProps {
  content: string;
  children: React.ReactNode;
}

const Tooltip: React.FC<TooltipProps> = ({ content, children }) => {
  const [visible, setVisible] = useState(false);
  const [isLeft, setIsLeft] = useState(false);
  const tooltipRef = useRef<HTMLDivElement | null>(null);

  const handleToggle = () => {
    if (tooltipRef.current) {
      const rect = tooltipRef.current.getBoundingClientRect();
      setIsLeft(rect.left + (rect.width / 2) < window.innerWidth / 2);
    }
    setVisible(!visible);
  };

  const handleClickOutside = (event: MouseEvent) => {
    if (tooltipRef.current && !tooltipRef.current.contains(event.target as Node)) {
      setVisible(false);
    }
  };

  useEffect(() => {
    document.addEventListener('click', handleClickOutside);
    return () => {
      document.removeEventListener('click', handleClickOutside);
    };
  }, []);

  return (
    <div
      ref={tooltipRef}
      className="relative inline-flex items-center cursor-pointer leading-none"
      onClick={handleToggle}
    >
      {children}
      {visible && (
        <div
          className={`absolute bottom-full mb-2 z-50 ${isLeft ? 'left-0' : 'right-0'} px-2.5 py-1.5 md:px-3.5 md:py-2.5 bg-neutral-900/95 text-text-inverse text-sm md:text-base leading-snug rounded-lg w-52 md:w-80 max-h-24 md:max-h-none overflow-y-auto shadow-lg`}
        >
          {content}
        </div>
      )}
    </div>
  );
};

export default Tooltip;
